"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedStringFromEndDate = exports.getLocalizedStringFromStartDate = exports.getLocalizedEndDateFromString = exports.getLocalizedStartDateFromString = exports.isValidDate = exports.getKeyFromArrayedPath = exports.updateField = exports.extractKeys = exports.isVoucherField = exports.isParsedJson = exports.toParsedJson = exports.setField = exports.getVoucherValue = exports.getField = void 0;
var util_1 = require("remota-common/util");
var object_1 = require("./object");
var moment_1 = __importDefault(require("moment"));
function getField(item, key) {
    var res = (0, object_1.get)(item, key);
    return isParsedJsonOrUndefined(res) ? res : undefined;
}
exports.getField = getField;
function getVoucherValue(item, key, isAlsoDeleted) {
    if (isAlsoDeleted === void 0) { isAlsoDeleted = false; }
    var excessDeleted = isAlsoDeleted ? item : removeDeletedLine(item);
    return getFromParsedJson(key ? getField(excessDeleted, key) : excessDeleted);
}
exports.getVoucherValue = getVoucherValue;
function isParsedJsonOrUndefined(item) {
    if (item === undefined || isParsedJson(item)) {
        return true;
    }
    else if (!item || typeof item !== "object") {
        return false;
    }
    else if (Array.isArray(item)) {
        return item.every(function (v) { return isParsedJsonOrUndefined(v); });
    }
    else {
        return Object.keys(item).every(function (key) { return isParsedJsonOrUndefined(item[key]); });
    }
}
function getFromParsedJson(parsedJson) {
    if (parsedJson === null || typeof parsedJson !== "object") {
        return parsedJson;
    }
    else if (parsedJson === undefined) {
        return undefined;
    }
    else if (isVoucherField(parsedJson)) {
        return getFromVoucherField(parsedJson);
    }
    else if (Array.isArray(parsedJson)) {
        return parsedJson.map(function (j) { return getFromParsedJson(j); });
    }
    else {
        return Object.keys(parsedJson).reduce(function (prev, key) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = getFromParsedJson(parsedJson[key]), _a)));
        }, {});
    }
}
function getFromVoucherField(voucherField) {
    var _a;
    if (voucherField.originalValue) {
        return voucherField.originalValue;
    }
    return (_a = voucherField.editedValue) !== null && _a !== void 0 ? _a : voucherField.plainValue;
}
function setField(item, key, field) {
    return (0, object_1.set)(item, key, field);
}
exports.setField = setField;
/**
 * 任意のオブジェクトから ParsedJson を生成する。
 * @param item
 */
function toParsedJson(item) {
    if (isParsedJson(item)) {
        return item;
    }
    else if (item === undefined || item === null) {
        return {};
    }
    else if ((0, util_1.isValueType)(item)) {
        return { editedValue: item };
    }
    else if (Array.isArray(item)) {
        return item.map(function (i) { return toParsedJson(i); });
    }
    else {
        return Object.keys(item).reduce(function (prev, key) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = toParsedJson(item[key]), _a)));
        }, {});
    }
}
exports.toParsedJson = toParsedJson;
function isParsedJson(item) {
    if (!item || typeof item !== "object" || item instanceof Date) {
        return false;
    }
    else if (isVoucherField(item)) {
        return true;
    }
    else if (Array.isArray(item)) {
        return item.every(function (v) { return isParsedJson(v); });
    }
    else {
        return Object.keys(item).every(function (key) { return isParsedJson(item[key]); });
    }
}
exports.isParsedJson = isParsedJson;
function isVoucherField(item) {
    if (!item || typeof item !== "object" || Array.isArray(item) || item instanceof Date) {
        return false;
    }
    var voucherFieldKeys = [
        "fieldType",
        "meta",
        "plainValue",
        "plainPosition",
        "confidence",
        "editedValue",
        "editedPosition",
        "displayValue",
        "originalValue",
        "readonly",
    ];
    return Object.keys(item).every(function (key) { return voucherFieldKeys.includes(key); });
}
exports.isVoucherField = isVoucherField;
function extractKeys(item) {
    return extract(item, "");
}
exports.extractKeys = extractKeys;
function extract(item, prefix) {
    if (!item) {
        return [];
    }
    else if (isVoucherField(item)) {
        return item.meta ? [] : [prefix];
    }
    else if (Array.isArray(item)) {
        return item.reduce(function (prev, x, i) { return prev.concat(extract(x, "".concat(prefix, "[").concat(i, "]"))); }, []);
    }
    else {
        return Object.keys(item).reduce(function (prev, key) {
            var nextPrefix = prefix ? "".concat(prefix, ".").concat(key) : key;
            return prev.concat(extract(item[key], nextPrefix));
        }, []);
    }
}
function removeDeletedLine(item) {
    if (isVoucherField(item)) {
        return item;
    }
    else if (Array.isArray(item)) {
        return item
            .filter(function (i) {
            var _a, _b;
            return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.isDeleted) === null || _b === void 0 ? void 0 : _b.plainValue) !== true;
        })
            .map(function (i) { return removeDeletedLine(i); });
    }
    else {
        if (typeof item !== "object")
            return item;
        return Object.keys(item || {}).reduce(function (prev, key) {
            var _a;
            var _b, _c;
            var v = item[key];
            return !v || ((_c = (_b = v) === null || _b === void 0 ? void 0 : _b.isDeleted) === null || _c === void 0 ? void 0 : _c.plainValue) === true ? prev : __assign(__assign({}, prev), (_a = {}, _a[key] = removeDeletedLine(v), _a));
        }, {});
    }
}
function updateField(item, key, value) {
    var current = getField(item, key);
    if (!current) {
        return setField(item, key, toParsedJson(value));
    }
    else if (isVoucherField(current)) {
        return setField(item, key, __assign(__assign({}, current), { editedValue: value }));
    }
    else if (Array.isArray(current)) {
        return current.reduce(function (prev, _, i) {
            return updateField(prev, key.replace("*", i.toString()), value);
        }, item);
    }
    else {
        return Object.keys(current).reduce(function (prev, k) {
            return updateField(prev, key.replace("*", k), value);
        }, item);
    }
}
exports.updateField = updateField;
function getKeyFromArrayedPath(path) {
    return path.map(function (path, index) { return (index === 0 ? path : Number.isInteger(path) ? "[".concat(path, "]") : ".".concat(path)); }).join("");
}
exports.getKeyFromArrayedPath = getKeyFromArrayedPath;
var isValidDate = function (date) { return !Number.isNaN(date.getTime()); };
exports.isValidDate = isValidDate;
function getLocalizedStartDateFromString(date) {
    var startDateInDateFormat = (0, exports.isValidDate)(new Date(date)) ? new Date(date) : undefined;
    if (!startDateInDateFormat) {
        return undefined;
    }
    startDateInDateFormat.setHours(startDateInDateFormat.getHours() - 9, 0, 0, 0);
    return startDateInDateFormat.toISOString();
}
exports.getLocalizedStartDateFromString = getLocalizedStartDateFromString;
function getLocalizedEndDateFromString(date) {
    var endDateInDateFormat = (0, exports.isValidDate)(new Date(date)) ? new Date(date) : undefined;
    if (!endDateInDateFormat) {
        return undefined;
    }
    endDateInDateFormat.setHours(endDateInDateFormat.getHours() + 14, 59, 59, 999); // Here adding only 14 hours instead of 23 to handle the JST offset
    return endDateInDateFormat.toISOString();
}
exports.getLocalizedEndDateFromString = getLocalizedEndDateFromString;
function getLocalizedStringFromStartDate(date) {
    if (!date) {
        return undefined;
    }
    var startDateInDateFormat = (0, exports.isValidDate)(new Date(date)) ? new Date(date) : undefined;
    if (!startDateInDateFormat) {
        return undefined;
    }
    startDateInDateFormat.setHours(startDateInDateFormat.getHours() + 9, 0, 0, 0);
    return (0, moment_1.default)(startDateInDateFormat).format("YYYY-MM-DD");
}
exports.getLocalizedStringFromStartDate = getLocalizedStringFromStartDate;
function getLocalizedStringFromEndDate(date) {
    if (!date) {
        return undefined;
    }
    var endDateInDateFormat = (0, exports.isValidDate)(new Date(date)) ? new Date(date) : undefined;
    if (!endDateInDateFormat) {
        return undefined;
    }
    endDateInDateFormat.setHours(endDateInDateFormat.getHours() - 14, 59, 59, 999); // Here adding only 14 hours instead of 23 to handle the JST offset
    return (0, moment_1.default)(endDateInDateFormat).format("YYYY-MM-DD");
}
exports.getLocalizedStringFromEndDate = getLocalizedStringFromEndDate;
